import React from "react";
import StandAloneComplaintMasterLayout from "../masterLayout/StandAloneComplaintMasterLayout";
import StandAloneComplainFormPage from "../components/StandAloneComplainFormPage";
import { Breadcrumb } from "react-bootstrap";

const StandAloneComplainForm = () => {
  return (
    <React.Fragment>
      <StandAloneComplaintMasterLayout>
        <Breadcrumb title="Complaint Management System" />
        <StandAloneComplainFormPage />
      </StandAloneComplaintMasterLayout>
    </React.Fragment>
  );
};

export default StandAloneComplainForm;
